module.exports = __webpack_public_path__ + "img/img.6b663afe.png";